import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  elite: {
    width: '100%',
  },
  eliteHead: {
    background: '#192542',
    borderRadius: '4px 4px 0 0',
    padding: '40px 20px',
    color: '#fff',
    '&.--affiliate': {
      borderRadius: 0,
    },
  },

  '@keyframes animateBar': {
    '0%': {
      backgroundSize: 0,
      opacity: 0.5,
    },
    '100%': {
      opacity: 1,
      backgroundSize: '100%',
    },
  },

  '@keyframes showLevel': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  eliteSlidePremium: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',

    '&:before': {
      content: '""',
      width: '100%',
      height: 9,
      backgroundColor: '#333',
      backgroundRepeat: 'no-repeat',
      borderRadius: 20,
      top: 'calc((100% / 2) - 8px)',
      left: 0,
      position: 'absolute',
      boxShadow: '0 0 5px -2px #000',
      animation: 'animateBar 1.5s linear',
      backgroundImage: 'linear-gradient(90deg, #222 78%, #DFBF74 100%)',
    },

    '&.--golden:before': {
      backgroundImage: 'linear-gradient(90deg, #DFBF74 78%, #AB7120 100%)',
    },
  },

  eliteSlide: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',

    '&:before': {
      content: '""',
      width: '100%',
      height: 10,
      backgroundColor: '#333',
      backgroundRepeat: 'no-repeat',
      backgroundImage: 'linear-gradient(90deg, #FFF 50%, #CC1C0B 75%)',
      borderRadius: 20,
      top: 'calc((100% / 2) - 8px)',
      left: 0,
      position: 'absolute',
      boxShadow: '0 0 5px -2px #000',
      animation: 'animateBar 1.5s linear',
    },

    '&.--red': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #CC1C0B 50%, #FF5E1F 75%)',
      },
    },

    '&.--orange': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #FF5E1F 50%, #007E38 75%)',
      },
    },

    '&.--green': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #007E38 50%, rgba(0,0,0,0.00) 75%)',
      },
    },

    '&.--black': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #222 78%, #DFBF74 100%)',
      },
    },

    '&.--affiliate10': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, rgb(51, 51, 51) 25%, #333333 40%, rgb(51, 51, 51) 60%)',
      },
    },

    '&.--affiliate50': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #333333 40%, rgb(51, 51, 51) 60%)',
      },
    },

    '&.--affiliate100': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 45%, #333333 65%, rgb(51, 51, 51) 90%)',
      },
    },

    '&.--affiliate500': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 45%, #0099ff 75%, rgb(51, 51, 51) 90%)',
      },
    },

    '&.--affiliateHigh': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 75%, #e6e600 85%, #e6e600 100%)',
      },
    },
  },

  eliteSlideItem: {
    padding: '0 6px',
    textAlign: 'center',
    position: 'relative',

    '&.--active': {
      '&:before': {
        width: 16,
        height: 16,
        borderRadius: '50%',
        background: 'white',
        position: 'absolute',
        content: '""',
        top: 'calc((100% / 2) - 11px)',
        left: 'calc((100% / 2) - 8px)',
        zIndex: 3,
        animation: 'showLevel 1.5s linear',
        boxShadow: '0 0 5px -2px #000',
      },
    },

    '& label': {
      display: 'block',
      fontWeight: 500,
      marginBottom: 24,
      fontSize: 14,
      color: '#586375',
    },

    '& span': {
      fontSize: 15,
      color: '#586375',
    },
  },
}));
